import { useState } from "react";
import Modal from "../../../../parts/modal-new";
import ModalFooter from "../../../../parts/modals/ModalFooter";
import { getIntervalString } from "../../../../utils/stripe-helpers";
import Select from "../../../../parts/inputs/select";

export const PlanTrial = ({ plan = {} }) => {
  const { id, metadata, recurring } = plan;
  const [trialDays, setTrialDays] = useState(metadata?.trial_days);

  const [hasFreeTrial, setHasFreeTrial] = useState(!!trialDays);
  const maxDays = recurring?.interval === "week" ? 7 : 30;

  return (
    <Modal
      className="plan-modal trial"
      toClear={["plan", "type"]}
      title={`Edit ${getIntervalString(recurring)} plan`}
    >
      <form
        className="body"
        action="/actions/plan-manager/add-trial"
        method="POST"
        data-noreset
        id="add-trial"
      >
        <input type="hidden" name="id" value={id} />
        <div className="modal-body">
          <div className="row">
            <div className="group">
              <label className="label" htmlFor="switch">
                Add free trial (optional)
              </label>

              <input
                type="checkbox"
                id="switch"
                role="switch"
                name="hasFreeTrial"
                checked={hasFreeTrial}
                onChange={() => setHasFreeTrial((state) => !state)}
              />
            </div>
          </div>

          <div className="row">
            <div className="group">
              <Select
                title="Free trial days"
                name="trial_days"
                id="trial_days"
                value={trialDays || 1}
                disabled={!hasFreeTrial}
                onChange={(val) => setTrialDays(val)}
                options={Array.from({ length: maxDays }, (v, i) => {
                  return {
                    text: i + 1,
                    value: i + 1,
                  };
                })}
              />
            </div>
          </div>
        </div>
      </form>
      <ModalFooter
        isSubmitButton
        showAltButton={false}
        onClickButton={() => {}}
        classNameButton="button save"
        formId="add-trial"
      />
    </Modal>
  );
};
